import type { SVGProps } from "react"

export default function FormHelperErrorIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="8" cy="8" r="7" stroke="#D32F2F" strokeWidth="1.5" />
      <path d="M8 4.5V9" stroke="#D32F2F" strokeWidth="1.5" strokeLinecap="round" />
      <circle cx="8" cy="11.5" r="0.75" fill="#D32F2F" />
    </svg>
  )
}
